import { ModifiedWidget, Widget as WidgetType } from 'types'

const VARIANT_METRIC_REPLACEMENTS: Record<string, string> = {
    revenue__sum: 'variant_revenue__sum',
    revenue_1p__sum: 'variant_revenue_1p__sum',
    revenue_3p__sum: 'variant_revenue_3p__sum',
    units_3p__sum: 'variant_units_3p__sum',
    units_1p__sum: 'variant_units_1p__sum',
    units__sum: 'variant_units__sum',
    sales_price: 'variant_sales_price',
    sales__sum: 'variant_sales__sum',
    sales_1p__sum: 'variant_sales_1p__sum',
    sales_3p__sum: 'variant_sales_3p__sum',
}

function updateWidgetToVariantLevel(
    widget: WidgetType | ModifiedWidget
): WidgetType {
    const widgetAsString = JSON.stringify(widget)

    let updatedWidgetString = widgetAsString
    Object.entries(VARIANT_METRIC_REPLACEMENTS).forEach(
        ([original, replacement]) => {
            // include starting quotation marks to avoid partial matches
            const regex = new RegExp(`"${original}`, 'g')
            updatedWidgetString = updatedWidgetString.replace(
                regex,
                `"${replacement}`
            )
        }
    )

    const updatedWidget = JSON.parse(updatedWidgetString) as WidgetType

    return {
        ...updatedWidget,
        data_source_settings: {
            ...updatedWidget.data_source_settings,
            is_variant_level: true,
        },
        filters: {
            ...updatedWidget.filters,
            // Remove any variant-level segment filters when migrating to parent level
            segments: [],
        },
    }
}

function migrateWidgetToParentLevel(
    widget: WidgetType | ModifiedWidget
): WidgetType {
    const widgetAsString = JSON.stringify(widget)
    let updatedWidgetString = widgetAsString
    Object.entries(VARIANT_METRIC_REPLACEMENTS).forEach(
        ([original, replacement]) => {
            // include starting quotation marks to avoid partial matches
            const regex = new RegExp(`"${replacement}`, 'g')
            updatedWidgetString = updatedWidgetString.replace(
                regex,
                `"${original}`
            )
        }
    )

    const updatedWidget = JSON.parse(updatedWidgetString) as WidgetType

    return {
        ...updatedWidget,
        data_source_settings: {
            ...updatedWidget.data_source_settings,
            is_variant_level: false,
        },
        filters: {
            ...updatedWidget.filters,
            // Remove any variant-level segment filters when migrating to parent level
            segments: [],
        },
    }
}
export { updateWidgetToVariantLevel, migrateWidgetToParentLevel }
